import Module from '../module';


class Header extends Module {

	constructor(options?: {
		cssId: {},
		slug: string
	}) {
		super('Home Header Module');
	}

	startup() {
		this.msg('startup');
	}

	bind() {
		this.msg('bind');
	}
}

export default Header;